module.exports = __webpack_public_path__ + "77caff83ab0bb4c5ae0094bcf82f1390.png";